'use es6';

import { Record } from 'immutable';
export default Record({
  targetGoogleSearch: false,
  targetSearchNetwork: false,
  targetContentNetwork: false
});